export const FIRESTOP_LABEL_TYPE = 'FIRESTOP_LABEL';
